import {MIN_SEARCH_LENGTH} from '../../consts';

import {FIELD_NAME, FIELD_EMAIL, FIELD_PHONE, FIELD_DESCRIPTION, FIELD_ROLE} from './consts';
// @ts-expect-error
import {ContactFormFieldTypes} from './types';

export const shouldShowPotentialContacts = (
    name: string | null | undefined,
    description: string | null | undefined,
    phoneNumber: string | null | undefined,
    email: string | null | undefined,
    hasRelatedAccounts: boolean
) => {
    return (
        hasRelatedAccounts ||
        (name && name.length >= MIN_SEARCH_LENGTH) ||
        (description && description.length >= MIN_SEARCH_LENGTH) ||
        (phoneNumber && phoneNumber.length >= MIN_SEARCH_LENGTH) ||
        (email && email.length >= MIN_SEARCH_LENGTH)
    );
};

export const shouldAllowCreate = (
    isTemporary: boolean,
    name?: string | null,
    phoneNumber?: string | null,
    email?: string | null
) => {
    return (
        !isTemporary &&
        ((name && name.length >= MIN_SEARCH_LENGTH) ||
            (phoneNumber && phoneNumber.length >= MIN_SEARCH_LENGTH) ||
            (email && email.length >= MIN_SEARCH_LENGTH))
    );
};

export const handleKeyboardNavigation = (
    e: React.KeyboardEvent,
    hasContactParentAccount: boolean,
    currentField: ContactFormFieldTypes,
    emailRef: React.Ref<HTMLInputElement | null | undefined | null>,
    phoneRef: React.Ref<HTMLInputElement | null | undefined | null>,
    descriptionRef: React.Ref<HTMLInputElement | null | undefined | null>,
    roleRef: React.Ref<HTMLInputElement | null | undefined | null>,
    nameRef: React.Ref<HTMLInputElement | null | undefined | null>
) => {
    switch (e.key) {
        case 'ArrowDown':
            if (currentField === FIELD_NAME)
                // @ts-expect-error
                descriptionRef.current && descriptionRef.current.focus();
            if (currentField === FIELD_DESCRIPTION) {
                if (hasContactParentAccount) {
                    // @ts-expect-error
                    roleRef.current && roleRef.current.focus();
                } else {
                    // @ts-expect-error
                    phoneRef.current && phoneRef.current.focus();
                }
            }
            // @ts-expect-error
            if (currentField === FIELD_ROLE) phoneRef.current && phoneRef.current.focus();
            // @ts-expect-error
            if (currentField === FIELD_PHONE) emailRef.current && emailRef.current.focus();
            // @ts-expect-error
            if (currentField === FIELD_EMAIL) nameRef.current && nameRef.current.focus();

            break;
        case 'ArrowUp':
            // @ts-expect-error
            if (currentField === FIELD_NAME) emailRef.current && emailRef.current.focus();
            // @ts-expect-error
            if (currentField === FIELD_DESCRIPTION) nameRef.current && nameRef.current.focus();
            if (currentField === FIELD_ROLE)
                // @ts-expect-error
                descriptionRef.current && descriptionRef.current.focus();
            if (currentField === FIELD_PHONE) {
                if (hasContactParentAccount) {
                    // @ts-expect-error
                    roleRef.current && roleRef.current.focus();
                } else {
                    // @ts-expect-error
                    descriptionRef.current && descriptionRef.current.focus();
                }
            }
            // @ts-expect-error
            if (currentField === FIELD_EMAIL) phoneRef.current && phoneRef.current.focus();

            break;
    }
};
